export const VOICE_MESSAGE_FILE_PREFIX = 'voice-message'
export const VOICE_MESSAGE_SUB_TYPE = 'voice' as const

export const MIN_VOICE_DURATION_MS = 1000
export const MAX_VOICE_DURATION_MS = 60 * 60 * 1000
export const MAX_VOICE_FILE_SIZE_BYTES = 50 * 1024 * 1024

export const WAVEFORM_BARS_COUNT = 48
export const RECORDING_TIMESLICE_MS = 100
export const VOICE_TRANSCRIBE_MOCK_DELAY_MS = 1600

export const VOICE_RECORDING_INFO_TYPE = 'voice-message-recording'

export const VOICE_PLAYBACK_RATE_STORAGE_KEY = 'voice-message-playback-rate'
export const VOICE_VOLUME_STORAGE_KEY = 'voice-message-volume'
export const VOICE_PLAYBACK_RATE_MIN = 0.5
export const VOICE_PLAYBACK_RATE_MAX = 2
export const VOICE_PLAYBACK_RATE_STEP = 0.1
export const VOICE_PLAYBACK_RATES = [0.5, 1, 1.2, 1.5, 1.7, 2] as const

export const VoiceRecorderStatus = {
  idle: 'idle',
  recording: 'recording',
  paused: 'paused',
  sending: 'sending',
} as const

export type VoiceRecorderStatus = typeof VoiceRecorderStatus[keyof typeof VoiceRecorderStatus]
